var map = {
	"./add-host.svg": 64386,
	"./alert.svg": 76568,
	"./announcement.svg": 46427,
	"./archives.svg": 44627,
	"./area-chart.svg": 42710,
	"./arrow-back.svg": 33063,
	"./arrow-down.svg": 68402,
	"./arrow-left.svg": 88633,
	"./arrow-right.svg": 7172,
	"./arrow-up.svg": 13825,
	"./asterisk.svg": 39082,
	"./at.svg": 36141,
	"./attention.svg": 70632,
	"./bar-graph.svg": 60454,
	"./bell-filled.svg": 12622,
	"./bell-off.svg": 38425,
	"./bell.svg": 89749,
	"./book.svg": 19501,
	"./box.svg": 67973,
	"./building.svg": 92682,
	"./bulb.svg": 68467,
	"./calendar.svg": 28844,
	"./cancel-circle.svg": 69701,
	"./caret-down.svg": 50308,
	"./caret-right.svg": 49734,
	"./chat.svg": 16692,
	"./check-circle.svg": 40403,
	"./check.svg": 68342,
	"./chevron-down.svg": 14724,
	"./chevron-left.svg": 8003,
	"./chevron-right.svg": 70726,
	"./chevron-up.svg": 77375,
	"./circle-minus.svg": 25877,
	"./circle-plus.svg": 30071,
	"./circle.svg": 33406,
	"./clipboard.svg": 97316,
	"./clock.svg": 76292,
	"./clone.svg": 12541,
	"./code.svg": 64725,
	"./collapse.svg": 15447,
	"./compose.svg": 77518,
	"./context.svg": 48719,
	"./copy.svg": 93477,
	"./credit-card.svg": 9868,
	"./currency.svg": 71603,
	"./dash.svg": 11494,
	"./dashboard.svg": 42406,
	"./dashboardB.svg": 3736,
	"./delete.svg": 70767,
	"./deny.svg": 57552,
	"./description.svg": 60460,
	"./download.svg": 62806,
	"./drag.svg": 83652,
	"./drop-target.svg": 83653,
	"./educate.svg": 32699,
	"./email-monochrome.svg": 96196,
	"./enterprise.svg": 7283,
	"./envelope.svg": 36758,
	"./equals.svg": 72229,
	"./error.svg": 68108,
	"./exclamation-warning.svg": 22130,
	"./exclusion.svg": 29702,
	"./expand.svg": 51290,
	"./export.svg": 97096,
	"./extension.svg": 46425,
	"./eye-slash.svg": 79669,
	"./eye.svg": 59913,
	"./file-binary.svg": 41962,
	"./file-code.svg": 52582,
	"./filter.svg": 56932,
	"./fingerprint.svg": 92638,
	"./flag.svg": 47700,
	"./flame.svg": 41023,
	"./forward.svg": 39061,
	"./gear-outline.svg": 7354,
	"./gear.svg": 3295,
	"./genius.svg": 96209,
	"./gift.svg": 62208,
	"./github.svg": 22283,
	"./google.svg": 73211,
	"./group.svg": 61367,
	"./heart-empty.svg": 48878,
	"./heart-full.svg": 58624,
	"./help.svg": 24039,
	"./heroku.svg": 48798,
	"./histogram.svg": 96160,
	"./history.svg": 21814,
	"./id-badge.svg": 8191,
	"./info-outline.svg": 76463,
	"./keyboard.svg": 14525,
	"./keys.svg": 23698,
	"./launch.svg": 34823,
	"./layers.svg": 99932,
	"./line-chart.svg": 23651,
	"./link.svg": 10622,
	"./lock.svg": 74399,
	"./magic.svg": 69579,
	"./magnet.svg": 17764,
	"./microscope.svg": 28902,
	"./monitor.svg": 12492,
	"./moon.svg": 37509,
	"./more-alt.svg": 80595,
	"./more.svg": 82065,
	"./no-keys.svg": 46216,
	"./org-tree.svg": 23401,
	"./pagerduty-monochrome.svg": 24211,
	"./paper-clip.svg": 90543,
	"./pause-circle.svg": 62313,
	"./pause.svg": 38908,
	"./pencil.svg": 91741,
	"./pin.svg": 63531,
	"./pipeline-icons/aggregate-dark.svg": 48926,
	"./pipeline-icons/aggregate-light.svg": 79102,
	"./pipeline-icons/aggregate-v2-dark.svg": 71323,
	"./pipeline-icons/aggregate-v2-light.svg": 41489,
	"./pipeline-icons/azure-blob-storage-dark.svg": 60500,
	"./pipeline-icons/azure-blob-storage-light.svg": 67996,
	"./pipeline-icons/azure-event-hub-dark.svg": 10013,
	"./pipeline-icons/azure-event-hub-light.svg": 4171,
	"./pipeline-icons/blackhole-dark.svg": 24784,
	"./pipeline-icons/blackhole-light.svg": 12480,
	"./pipeline-icons/clickhouse-dark.svg": 38453,
	"./pipeline-icons/clickhouse-light.svg": 21235,
	"./pipeline-icons/cloudwatch-logs-dark.svg": 19193,
	"./pipeline-icons/cloudwatch-logs-light.svg": 23247,
	"./pipeline-icons/cloudwatch-metrics-dark.svg": 80797,
	"./pipeline-icons/cloudwatch-metrics-light.svg": 43915,
	"./pipeline-icons/clustering-dark.svg": 66223,
	"./pipeline-icons/clustering-light.svg": 78285,
	"./pipeline-icons/compact-fields-dark.svg": 65816,
	"./pipeline-icons/compact-fields-light.svg": 1048,
	"./pipeline-icons/conditional-dark.svg": 6529,
	"./pipeline-icons/conditional-light.svg": 57927,
	"./pipeline-icons/data-profiler-dark.svg": 90999,
	"./pipeline-icons/data-profiler-light.svg": 72293,
	"./pipeline-icons/datadog-logs-dark.svg": 71879,
	"./pipeline-icons/datadog-logs-light.svg": 66101,
	"./pipeline-icons/datadog-metrics-dark.svg": 14319,
	"./pipeline-icons/datadog-metrics-light.svg": 4141,
	"./pipeline-icons/decrypt-fields-dark.svg": 10732,
	"./pipeline-icons/decrypt-fields-light.svg": 23268,
	"./pipeline-icons/dedupe-dark.svg": 73002,
	"./pipeline-icons/dedupe-light.svg": 15826,
	"./pipeline-icons/demo-logs-dark.svg": 54992,
	"./pipeline-icons/demo-logs-light.svg": 2176,
	"./pipeline-icons/drop-fields-dark.svg": 23392,
	"./pipeline-icons/drop-fields-light.svg": 7504,
	"./pipeline-icons/elasticsearch-dark.svg": 70774,
	"./pipeline-icons/elasticsearch-light.svg": 89062,
	"./pipeline-icons/encrypt-fields-dark.svg": 64436,
	"./pipeline-icons/encrypt-fields-light.svg": 26844,
	"./pipeline-icons/event-to-metric-dark.svg": 2196,
	"./pipeline-icons/event-to-metric-light.svg": 24316,
	"./pipeline-icons/filter-by-field-dark.svg": 88696,
	"./pipeline-icons/filter-by-field-light.svg": 27160,
	"./pipeline-icons/filter-dark.svg": 87547,
	"./pipeline-icons/filter-light.svg": 92625,
	"./pipeline-icons/flatten-fields-dark.svg": 51313,
	"./pipeline-icons/flatten-fields-light.svg": 28759,
	"./pipeline-icons/fluent-dark.svg": 80123,
	"./pipeline-icons/fluent-light.svg": 56465,
	"./pipeline-icons/fluentd-dark.svg": 37675,
	"./pipeline-icons/fluentd-light-light.svg": 96490,
	"./pipeline-icons/gcp-cloud-monitoring-dark.svg": 52154,
	"./pipeline-icons/gcp-cloud-monitoring-light.svg": 73730,
	"./pipeline-icons/gcp-cloud-operations-dark.svg": 5026,
	"./pipeline-icons/gcp-cloud-operations-light.svg": 8026,
	"./pipeline-icons/gcp-cloud-pubsub-dark.svg": 33463,
	"./pipeline-icons/gcp-cloud-pubsub-light.svg": 16901,
	"./pipeline-icons/gcp-cloud-storage-dark.svg": 89263,
	"./pipeline-icons/gcp-cloud-storage-light.svg": 52685,
	"./pipeline-icons/generic-destination-dark.svg": 69273,
	"./pipeline-icons/generic-destination-light.svg": 91759,
	"./pipeline-icons/generic-processor-dark.svg": 71901,
	"./pipeline-icons/generic-processor-light.svg": 67051,
	"./pipeline-icons/generic-source-dark.svg": 47192,
	"./pipeline-icons/generic-source-light.svg": 84920,
	"./pipeline-icons/grafana-metrics-dark.svg": 34209,
	"./pipeline-icons/grafana-metrics-light.svg": 50119,
	"./pipeline-icons/honeycomb-logs-dark.svg": 647,
	"./pipeline-icons/honeycomb-logs-light.svg": 16789,
	"./pipeline-icons/http-dark.svg": 27105,
	"./pipeline-icons/http-light.svg": 51399,
	"./pipeline-icons/js-script-dark.svg": 616,
	"./pipeline-icons/js-script-light.svg": 13544,
	"./pipeline-icons/kafka-dark.svg": 50671,
	"./pipeline-icons/kafka-light.svg": 75373,
	"./pipeline-icons/kinesis-firehose-dark.svg": 22605,
	"./pipeline-icons/kinesis-firehose-light.svg": 54523,
	"./pipeline-icons/kinesis-streams-dark.svg": 9383,
	"./pipeline-icons/kinesis-streams-light.svg": 60149,
	"./pipeline-icons/kubernetes.svg": 17760,
	"./pipeline-icons/log-analysis-dark.svg": 17902,
	"./pipeline-icons/log-analysis-light.svg": 2254,
	"./pipeline-icons/logstash-dark.svg": 38506,
	"./pipeline-icons/logstash-light.svg": 28274,
	"./pipeline-icons/loki-dark.svg": 25192,
	"./pipeline-icons/loki-light.svg": 89160,
	"./pipeline-icons/map-fields-dark.svg": 93929,
	"./pipeline-icons/map-fields-light.svg": 22239,
	"./pipeline-icons/metrics-tag-cardinality-limit-dark.svg": 95626,
	"./pipeline-icons/metrics-tag-cardinality-limit-light.svg": 48594,
	"./pipeline-icons/mezmo-agent-dark.svg": 60225,
	"./pipeline-icons/mezmo-agent-light.svg": 72359,
	"./pipeline-icons/mezmo-dark.svg": 40541,
	"./pipeline-icons/mezmo-datadog-source-dark.svg": 81138,
	"./pipeline-icons/mezmo-datadog-source-light.svg": 72106,
	"./pipeline-icons/mezmo-light.svg": 65995,
	"./pipeline-icons/new-relic-dark.svg": 8801,
	"./pipeline-icons/new-relic-light.svg": 94023,
	"./pipeline-icons/notification-channel-dark.svg": 54156,
	"./pipeline-icons/notification-channel-light.svg": 3652,
	"./pipeline-icons/open-telemetry-dark.svg": 35507,
	"./pipeline-icons/open-telemetry-light.svg": 85337,
	"./pipeline-icons/parse-dark.svg": 19581,
	"./pipeline-icons/parse-light.svg": 34514,
	"./pipeline-icons/parse-sequentially-dark.svg": 12459,
	"./pipeline-icons/parse-sequentially-light.svg": 60737,
	"./pipeline-icons/prometheus-remote-write-dark.svg": 18514,
	"./pipeline-icons/prometheus-remote-write-light.svg": 76330,
	"./pipeline-icons/pulsar-dark.svg": 45872,
	"./pipeline-icons/pulsar-light.svg": 66464,
	"./pipeline-icons/redact-dark.svg": 48336,
	"./pipeline-icons/redact-light.svg": 85120,
	"./pipeline-icons/redis-dark.svg": 81542,
	"./pipeline-icons/redis-light.svg": 49078,
	"./pipeline-icons/reduce-dark.svg": 50111,
	"./pipeline-icons/reduce-light.svg": 15037,
	"./pipeline-icons/replace-dark.svg": 24073,
	"./pipeline-icons/replace-light.svg": 13631,
	"./pipeline-icons/route-dark.svg": 51592,
	"./pipeline-icons/route-light.svg": 12904,
	"./pipeline-icons/s3-dark.svg": 84607,
	"./pipeline-icons/s3-light.svg": 27933,
	"./pipeline-icons/sample-dark.svg": 98099,
	"./pipeline-icons/sample-light.svg": 23289,
	"./pipeline-icons/set-timestamp-dark.svg": 52304,
	"./pipeline-icons/set-timestamp-light.svg": 54176,
	"./pipeline-icons/splunk-dark.svg": 23582,
	"./pipeline-icons/splunk-hec-light.svg": 22149,
	"./pipeline-icons/splunk-hec-logs-dark.svg": 74059,
	"./pipeline-icons/splunk-hec-logs-light.svg": 89665,
	"./pipeline-icons/sqs-dark.svg": 16148,
	"./pipeline-icons/sqs-light.svg": 86972,
	"./pipeline-icons/stringify-dark.svg": 28916,
	"./pipeline-icons/stringify-light.svg": 40700,
	"./pipeline-icons/sumo-logic-logs-dark.svg": 86088,
	"./pipeline-icons/sumo-logic-logs-light.svg": 32360,
	"./pipeline-icons/sumo-logic-metrics-dark.svg": 39382,
	"./pipeline-icons/sumo-logic-metrics-light.svg": 2278,
	"./pipeline-icons/throttle-dark.svg": 97869,
	"./pipeline-icons/throttle-light.svg": 15624,
	"./pipeline-icons/trace-sampling-dark.svg": 96500,
	"./pipeline-icons/trace-sampling-light.svg": 70044,
	"./pipeline-icons/transform-group-dark.svg": 51667,
	"./pipeline-icons/transform-group-input-dark.svg": 42686,
	"./pipeline-icons/transform-group-input-light.svg": 7614,
	"./pipeline-icons/transform-group-light.svg": 47225,
	"./pipeline-icons/unroll-dark.svg": 86685,
	"./pipeline-icons/unroll-light.svg": 61291,
	"./pipeline-icons/vector-dark.svg": 12874,
	"./pipeline-icons/vector-light.svg": 97458,
	"./pipeline-icons/vrl-dark.svg": 97125,
	"./pipeline-icons/vrl-light.svg": 61923,
	"./pipeline-icons/webhook-dark.svg": 41300,
	"./pipeline-icons/webhook-light.svg": 46076,
	"./play.svg": 2036,
	"./plug.svg": 53926,
	"./plus.svg": 47818,
	"./power.svg": 12185,
	"./privacy-lock.svg": 98230,
	"./pulse.svg": 59273,
	"./question.svg": 6670,
	"./quote.svg": 49698,
	"./refresh.svg": 13659,
	"./rewind.svg": 75451,
	"./ribbon.svg": 37034,
	"./rocket.svg": 22214,
	"./search-minus.svg": 16149,
	"./search-plus.svg": 64855,
	"./search.svg": 49118,
	"./security.svg": 33236,
	"./server.svg": 21079,
	"./shared-sources.svg": 46008,
	"./shield.svg": 29637,
	"./sign-out.svg": 74606,
	"./slack-monochrome.svg": 24392,
	"./sliders.svg": 37148,
	"./sort-asc.svg": 54358,
	"./sort-desc.svg": 11792,
	"./sparkles.svg": 74471,
	"./stack.svg": 38614,
	"./sun.svg": 37100,
	"./swap.svg": 63351,
	"./tag.svg": 83086,
	"./tap.svg": 42113,
	"./template-library.svg": 90338,
	"./terminal.svg": 21278,
	"./time-cycle.svg": 40844,
	"./toolbox.svg": 63847,
	"./tools.svg": 75247,
	"./trash.svg": 10096,
	"./trusted-profile-icon.svg": 86279,
	"./unfold.svg": 65834,
	"./union.svg": 4755,
	"./upload.svg": 28749,
	"./user.svg": 53767,
	"./verified.svg": 21486,
	"./views.svg": 9872,
	"./webhook-monochrome.svg": 88238,
	"./wrench.svg": 65169,
	"./x.svg": 90130,
	"./zap.svg": 53923,
	"@ui/styles/src/img/icons/add-host.svg": 64386,
	"@ui/styles/src/img/icons/alert.svg": 76568,
	"@ui/styles/src/img/icons/announcement.svg": 46427,
	"@ui/styles/src/img/icons/archives.svg": 44627,
	"@ui/styles/src/img/icons/area-chart.svg": 42710,
	"@ui/styles/src/img/icons/arrow-back.svg": 33063,
	"@ui/styles/src/img/icons/arrow-down.svg": 68402,
	"@ui/styles/src/img/icons/arrow-left.svg": 88633,
	"@ui/styles/src/img/icons/arrow-right.svg": 7172,
	"@ui/styles/src/img/icons/arrow-up.svg": 13825,
	"@ui/styles/src/img/icons/asterisk.svg": 39082,
	"@ui/styles/src/img/icons/at.svg": 36141,
	"@ui/styles/src/img/icons/attention.svg": 70632,
	"@ui/styles/src/img/icons/bar-graph.svg": 60454,
	"@ui/styles/src/img/icons/bell-filled.svg": 12622,
	"@ui/styles/src/img/icons/bell-off.svg": 38425,
	"@ui/styles/src/img/icons/bell.svg": 89749,
	"@ui/styles/src/img/icons/book.svg": 19501,
	"@ui/styles/src/img/icons/box.svg": 67973,
	"@ui/styles/src/img/icons/building.svg": 92682,
	"@ui/styles/src/img/icons/bulb.svg": 68467,
	"@ui/styles/src/img/icons/calendar.svg": 28844,
	"@ui/styles/src/img/icons/cancel-circle.svg": 69701,
	"@ui/styles/src/img/icons/caret-down.svg": 50308,
	"@ui/styles/src/img/icons/caret-right.svg": 49734,
	"@ui/styles/src/img/icons/chat.svg": 16692,
	"@ui/styles/src/img/icons/check-circle.svg": 40403,
	"@ui/styles/src/img/icons/check.svg": 68342,
	"@ui/styles/src/img/icons/chevron-down.svg": 14724,
	"@ui/styles/src/img/icons/chevron-left.svg": 8003,
	"@ui/styles/src/img/icons/chevron-right.svg": 70726,
	"@ui/styles/src/img/icons/chevron-up.svg": 77375,
	"@ui/styles/src/img/icons/circle-minus.svg": 25877,
	"@ui/styles/src/img/icons/circle-plus.svg": 30071,
	"@ui/styles/src/img/icons/circle.svg": 33406,
	"@ui/styles/src/img/icons/clipboard.svg": 97316,
	"@ui/styles/src/img/icons/clock.svg": 76292,
	"@ui/styles/src/img/icons/clone.svg": 12541,
	"@ui/styles/src/img/icons/code.svg": 64725,
	"@ui/styles/src/img/icons/collapse.svg": 15447,
	"@ui/styles/src/img/icons/compose.svg": 77518,
	"@ui/styles/src/img/icons/context.svg": 48719,
	"@ui/styles/src/img/icons/copy.svg": 93477,
	"@ui/styles/src/img/icons/credit-card.svg": 9868,
	"@ui/styles/src/img/icons/currency.svg": 71603,
	"@ui/styles/src/img/icons/dash.svg": 11494,
	"@ui/styles/src/img/icons/dashboard.svg": 42406,
	"@ui/styles/src/img/icons/dashboardB.svg": 3736,
	"@ui/styles/src/img/icons/delete.svg": 70767,
	"@ui/styles/src/img/icons/deny.svg": 57552,
	"@ui/styles/src/img/icons/description.svg": 60460,
	"@ui/styles/src/img/icons/download.svg": 62806,
	"@ui/styles/src/img/icons/drag.svg": 83652,
	"@ui/styles/src/img/icons/drop-target.svg": 83653,
	"@ui/styles/src/img/icons/educate.svg": 32699,
	"@ui/styles/src/img/icons/email-monochrome.svg": 96196,
	"@ui/styles/src/img/icons/enterprise.svg": 7283,
	"@ui/styles/src/img/icons/envelope.svg": 36758,
	"@ui/styles/src/img/icons/equals.svg": 72229,
	"@ui/styles/src/img/icons/error.svg": 68108,
	"@ui/styles/src/img/icons/exclamation-warning.svg": 22130,
	"@ui/styles/src/img/icons/exclusion.svg": 29702,
	"@ui/styles/src/img/icons/expand.svg": 51290,
	"@ui/styles/src/img/icons/export.svg": 97096,
	"@ui/styles/src/img/icons/extension.svg": 46425,
	"@ui/styles/src/img/icons/eye-slash.svg": 79669,
	"@ui/styles/src/img/icons/eye.svg": 59913,
	"@ui/styles/src/img/icons/file-binary.svg": 41962,
	"@ui/styles/src/img/icons/file-code.svg": 52582,
	"@ui/styles/src/img/icons/filter.svg": 56932,
	"@ui/styles/src/img/icons/fingerprint.svg": 92638,
	"@ui/styles/src/img/icons/flag.svg": 47700,
	"@ui/styles/src/img/icons/flame.svg": 41023,
	"@ui/styles/src/img/icons/forward.svg": 39061,
	"@ui/styles/src/img/icons/gear-outline.svg": 7354,
	"@ui/styles/src/img/icons/gear.svg": 3295,
	"@ui/styles/src/img/icons/genius.svg": 96209,
	"@ui/styles/src/img/icons/gift.svg": 62208,
	"@ui/styles/src/img/icons/github.svg": 22283,
	"@ui/styles/src/img/icons/google.svg": 73211,
	"@ui/styles/src/img/icons/group.svg": 61367,
	"@ui/styles/src/img/icons/heart-empty.svg": 48878,
	"@ui/styles/src/img/icons/heart-full.svg": 58624,
	"@ui/styles/src/img/icons/help.svg": 24039,
	"@ui/styles/src/img/icons/heroku.svg": 48798,
	"@ui/styles/src/img/icons/histogram.svg": 96160,
	"@ui/styles/src/img/icons/history.svg": 21814,
	"@ui/styles/src/img/icons/id-badge.svg": 8191,
	"@ui/styles/src/img/icons/info-outline.svg": 76463,
	"@ui/styles/src/img/icons/keyboard.svg": 14525,
	"@ui/styles/src/img/icons/keys.svg": 23698,
	"@ui/styles/src/img/icons/launch.svg": 34823,
	"@ui/styles/src/img/icons/layers.svg": 99932,
	"@ui/styles/src/img/icons/line-chart.svg": 23651,
	"@ui/styles/src/img/icons/link.svg": 10622,
	"@ui/styles/src/img/icons/lock.svg": 74399,
	"@ui/styles/src/img/icons/magic.svg": 69579,
	"@ui/styles/src/img/icons/magnet.svg": 17764,
	"@ui/styles/src/img/icons/microscope.svg": 28902,
	"@ui/styles/src/img/icons/monitor.svg": 12492,
	"@ui/styles/src/img/icons/moon.svg": 37509,
	"@ui/styles/src/img/icons/more-alt.svg": 80595,
	"@ui/styles/src/img/icons/more.svg": 82065,
	"@ui/styles/src/img/icons/no-keys.svg": 46216,
	"@ui/styles/src/img/icons/org-tree.svg": 23401,
	"@ui/styles/src/img/icons/pagerduty-monochrome.svg": 24211,
	"@ui/styles/src/img/icons/paper-clip.svg": 90543,
	"@ui/styles/src/img/icons/pause-circle.svg": 62313,
	"@ui/styles/src/img/icons/pause.svg": 38908,
	"@ui/styles/src/img/icons/pencil.svg": 91741,
	"@ui/styles/src/img/icons/pin.svg": 63531,
	"@ui/styles/src/img/icons/pipeline-icons/aggregate-dark.svg": 48926,
	"@ui/styles/src/img/icons/pipeline-icons/aggregate-light.svg": 79102,
	"@ui/styles/src/img/icons/pipeline-icons/aggregate-v2-dark.svg": 71323,
	"@ui/styles/src/img/icons/pipeline-icons/aggregate-v2-light.svg": 41489,
	"@ui/styles/src/img/icons/pipeline-icons/azure-blob-storage-dark.svg": 60500,
	"@ui/styles/src/img/icons/pipeline-icons/azure-blob-storage-light.svg": 67996,
	"@ui/styles/src/img/icons/pipeline-icons/azure-event-hub-dark.svg": 10013,
	"@ui/styles/src/img/icons/pipeline-icons/azure-event-hub-light.svg": 4171,
	"@ui/styles/src/img/icons/pipeline-icons/blackhole-dark.svg": 24784,
	"@ui/styles/src/img/icons/pipeline-icons/blackhole-light.svg": 12480,
	"@ui/styles/src/img/icons/pipeline-icons/clickhouse-dark.svg": 38453,
	"@ui/styles/src/img/icons/pipeline-icons/clickhouse-light.svg": 21235,
	"@ui/styles/src/img/icons/pipeline-icons/cloudwatch-logs-dark.svg": 19193,
	"@ui/styles/src/img/icons/pipeline-icons/cloudwatch-logs-light.svg": 23247,
	"@ui/styles/src/img/icons/pipeline-icons/cloudwatch-metrics-dark.svg": 80797,
	"@ui/styles/src/img/icons/pipeline-icons/cloudwatch-metrics-light.svg": 43915,
	"@ui/styles/src/img/icons/pipeline-icons/clustering-dark.svg": 66223,
	"@ui/styles/src/img/icons/pipeline-icons/clustering-light.svg": 78285,
	"@ui/styles/src/img/icons/pipeline-icons/compact-fields-dark.svg": 65816,
	"@ui/styles/src/img/icons/pipeline-icons/compact-fields-light.svg": 1048,
	"@ui/styles/src/img/icons/pipeline-icons/conditional-dark.svg": 6529,
	"@ui/styles/src/img/icons/pipeline-icons/conditional-light.svg": 57927,
	"@ui/styles/src/img/icons/pipeline-icons/data-profiler-dark.svg": 90999,
	"@ui/styles/src/img/icons/pipeline-icons/data-profiler-light.svg": 72293,
	"@ui/styles/src/img/icons/pipeline-icons/datadog-logs-dark.svg": 71879,
	"@ui/styles/src/img/icons/pipeline-icons/datadog-logs-light.svg": 66101,
	"@ui/styles/src/img/icons/pipeline-icons/datadog-metrics-dark.svg": 14319,
	"@ui/styles/src/img/icons/pipeline-icons/datadog-metrics-light.svg": 4141,
	"@ui/styles/src/img/icons/pipeline-icons/decrypt-fields-dark.svg": 10732,
	"@ui/styles/src/img/icons/pipeline-icons/decrypt-fields-light.svg": 23268,
	"@ui/styles/src/img/icons/pipeline-icons/dedupe-dark.svg": 73002,
	"@ui/styles/src/img/icons/pipeline-icons/dedupe-light.svg": 15826,
	"@ui/styles/src/img/icons/pipeline-icons/demo-logs-dark.svg": 54992,
	"@ui/styles/src/img/icons/pipeline-icons/demo-logs-light.svg": 2176,
	"@ui/styles/src/img/icons/pipeline-icons/drop-fields-dark.svg": 23392,
	"@ui/styles/src/img/icons/pipeline-icons/drop-fields-light.svg": 7504,
	"@ui/styles/src/img/icons/pipeline-icons/elasticsearch-dark.svg": 70774,
	"@ui/styles/src/img/icons/pipeline-icons/elasticsearch-light.svg": 89062,
	"@ui/styles/src/img/icons/pipeline-icons/encrypt-fields-dark.svg": 64436,
	"@ui/styles/src/img/icons/pipeline-icons/encrypt-fields-light.svg": 26844,
	"@ui/styles/src/img/icons/pipeline-icons/event-to-metric-dark.svg": 2196,
	"@ui/styles/src/img/icons/pipeline-icons/event-to-metric-light.svg": 24316,
	"@ui/styles/src/img/icons/pipeline-icons/filter-by-field-dark.svg": 88696,
	"@ui/styles/src/img/icons/pipeline-icons/filter-by-field-light.svg": 27160,
	"@ui/styles/src/img/icons/pipeline-icons/filter-dark.svg": 87547,
	"@ui/styles/src/img/icons/pipeline-icons/filter-light.svg": 92625,
	"@ui/styles/src/img/icons/pipeline-icons/flatten-fields-dark.svg": 51313,
	"@ui/styles/src/img/icons/pipeline-icons/flatten-fields-light.svg": 28759,
	"@ui/styles/src/img/icons/pipeline-icons/fluent-dark.svg": 80123,
	"@ui/styles/src/img/icons/pipeline-icons/fluent-light.svg": 56465,
	"@ui/styles/src/img/icons/pipeline-icons/fluentd-dark.svg": 37675,
	"@ui/styles/src/img/icons/pipeline-icons/fluentd-light-light.svg": 96490,
	"@ui/styles/src/img/icons/pipeline-icons/gcp-cloud-monitoring-dark.svg": 52154,
	"@ui/styles/src/img/icons/pipeline-icons/gcp-cloud-monitoring-light.svg": 73730,
	"@ui/styles/src/img/icons/pipeline-icons/gcp-cloud-operations-dark.svg": 5026,
	"@ui/styles/src/img/icons/pipeline-icons/gcp-cloud-operations-light.svg": 8026,
	"@ui/styles/src/img/icons/pipeline-icons/gcp-cloud-pubsub-dark.svg": 33463,
	"@ui/styles/src/img/icons/pipeline-icons/gcp-cloud-pubsub-light.svg": 16901,
	"@ui/styles/src/img/icons/pipeline-icons/gcp-cloud-storage-dark.svg": 89263,
	"@ui/styles/src/img/icons/pipeline-icons/gcp-cloud-storage-light.svg": 52685,
	"@ui/styles/src/img/icons/pipeline-icons/generic-destination-dark.svg": 69273,
	"@ui/styles/src/img/icons/pipeline-icons/generic-destination-light.svg": 91759,
	"@ui/styles/src/img/icons/pipeline-icons/generic-processor-dark.svg": 71901,
	"@ui/styles/src/img/icons/pipeline-icons/generic-processor-light.svg": 67051,
	"@ui/styles/src/img/icons/pipeline-icons/generic-source-dark.svg": 47192,
	"@ui/styles/src/img/icons/pipeline-icons/generic-source-light.svg": 84920,
	"@ui/styles/src/img/icons/pipeline-icons/grafana-metrics-dark.svg": 34209,
	"@ui/styles/src/img/icons/pipeline-icons/grafana-metrics-light.svg": 50119,
	"@ui/styles/src/img/icons/pipeline-icons/honeycomb-logs-dark.svg": 647,
	"@ui/styles/src/img/icons/pipeline-icons/honeycomb-logs-light.svg": 16789,
	"@ui/styles/src/img/icons/pipeline-icons/http-dark.svg": 27105,
	"@ui/styles/src/img/icons/pipeline-icons/http-light.svg": 51399,
	"@ui/styles/src/img/icons/pipeline-icons/js-script-dark.svg": 616,
	"@ui/styles/src/img/icons/pipeline-icons/js-script-light.svg": 13544,
	"@ui/styles/src/img/icons/pipeline-icons/kafka-dark.svg": 50671,
	"@ui/styles/src/img/icons/pipeline-icons/kafka-light.svg": 75373,
	"@ui/styles/src/img/icons/pipeline-icons/kinesis-firehose-dark.svg": 22605,
	"@ui/styles/src/img/icons/pipeline-icons/kinesis-firehose-light.svg": 54523,
	"@ui/styles/src/img/icons/pipeline-icons/kinesis-streams-dark.svg": 9383,
	"@ui/styles/src/img/icons/pipeline-icons/kinesis-streams-light.svg": 60149,
	"@ui/styles/src/img/icons/pipeline-icons/kubernetes.svg": 17760,
	"@ui/styles/src/img/icons/pipeline-icons/log-analysis-dark.svg": 17902,
	"@ui/styles/src/img/icons/pipeline-icons/log-analysis-light.svg": 2254,
	"@ui/styles/src/img/icons/pipeline-icons/logstash-dark.svg": 38506,
	"@ui/styles/src/img/icons/pipeline-icons/logstash-light.svg": 28274,
	"@ui/styles/src/img/icons/pipeline-icons/loki-dark.svg": 25192,
	"@ui/styles/src/img/icons/pipeline-icons/loki-light.svg": 89160,
	"@ui/styles/src/img/icons/pipeline-icons/map-fields-dark.svg": 93929,
	"@ui/styles/src/img/icons/pipeline-icons/map-fields-light.svg": 22239,
	"@ui/styles/src/img/icons/pipeline-icons/metrics-tag-cardinality-limit-dark.svg": 95626,
	"@ui/styles/src/img/icons/pipeline-icons/metrics-tag-cardinality-limit-light.svg": 48594,
	"@ui/styles/src/img/icons/pipeline-icons/mezmo-agent-dark.svg": 60225,
	"@ui/styles/src/img/icons/pipeline-icons/mezmo-agent-light.svg": 72359,
	"@ui/styles/src/img/icons/pipeline-icons/mezmo-dark.svg": 40541,
	"@ui/styles/src/img/icons/pipeline-icons/mezmo-datadog-source-dark.svg": 81138,
	"@ui/styles/src/img/icons/pipeline-icons/mezmo-datadog-source-light.svg": 72106,
	"@ui/styles/src/img/icons/pipeline-icons/mezmo-light.svg": 65995,
	"@ui/styles/src/img/icons/pipeline-icons/new-relic-dark.svg": 8801,
	"@ui/styles/src/img/icons/pipeline-icons/new-relic-light.svg": 94023,
	"@ui/styles/src/img/icons/pipeline-icons/notification-channel-dark.svg": 54156,
	"@ui/styles/src/img/icons/pipeline-icons/notification-channel-light.svg": 3652,
	"@ui/styles/src/img/icons/pipeline-icons/open-telemetry-dark.svg": 35507,
	"@ui/styles/src/img/icons/pipeline-icons/open-telemetry-light.svg": 85337,
	"@ui/styles/src/img/icons/pipeline-icons/parse-dark.svg": 19581,
	"@ui/styles/src/img/icons/pipeline-icons/parse-light.svg": 34514,
	"@ui/styles/src/img/icons/pipeline-icons/parse-sequentially-dark.svg": 12459,
	"@ui/styles/src/img/icons/pipeline-icons/parse-sequentially-light.svg": 60737,
	"@ui/styles/src/img/icons/pipeline-icons/prometheus-remote-write-dark.svg": 18514,
	"@ui/styles/src/img/icons/pipeline-icons/prometheus-remote-write-light.svg": 76330,
	"@ui/styles/src/img/icons/pipeline-icons/pulsar-dark.svg": 45872,
	"@ui/styles/src/img/icons/pipeline-icons/pulsar-light.svg": 66464,
	"@ui/styles/src/img/icons/pipeline-icons/redact-dark.svg": 48336,
	"@ui/styles/src/img/icons/pipeline-icons/redact-light.svg": 85120,
	"@ui/styles/src/img/icons/pipeline-icons/redis-dark.svg": 81542,
	"@ui/styles/src/img/icons/pipeline-icons/redis-light.svg": 49078,
	"@ui/styles/src/img/icons/pipeline-icons/reduce-dark.svg": 50111,
	"@ui/styles/src/img/icons/pipeline-icons/reduce-light.svg": 15037,
	"@ui/styles/src/img/icons/pipeline-icons/replace-dark.svg": 24073,
	"@ui/styles/src/img/icons/pipeline-icons/replace-light.svg": 13631,
	"@ui/styles/src/img/icons/pipeline-icons/route-dark.svg": 51592,
	"@ui/styles/src/img/icons/pipeline-icons/route-light.svg": 12904,
	"@ui/styles/src/img/icons/pipeline-icons/s3-dark.svg": 84607,
	"@ui/styles/src/img/icons/pipeline-icons/s3-light.svg": 27933,
	"@ui/styles/src/img/icons/pipeline-icons/sample-dark.svg": 98099,
	"@ui/styles/src/img/icons/pipeline-icons/sample-light.svg": 23289,
	"@ui/styles/src/img/icons/pipeline-icons/set-timestamp-dark.svg": 52304,
	"@ui/styles/src/img/icons/pipeline-icons/set-timestamp-light.svg": 54176,
	"@ui/styles/src/img/icons/pipeline-icons/splunk-dark.svg": 23582,
	"@ui/styles/src/img/icons/pipeline-icons/splunk-hec-light.svg": 22149,
	"@ui/styles/src/img/icons/pipeline-icons/splunk-hec-logs-dark.svg": 74059,
	"@ui/styles/src/img/icons/pipeline-icons/splunk-hec-logs-light.svg": 89665,
	"@ui/styles/src/img/icons/pipeline-icons/sqs-dark.svg": 16148,
	"@ui/styles/src/img/icons/pipeline-icons/sqs-light.svg": 86972,
	"@ui/styles/src/img/icons/pipeline-icons/stringify-dark.svg": 28916,
	"@ui/styles/src/img/icons/pipeline-icons/stringify-light.svg": 40700,
	"@ui/styles/src/img/icons/pipeline-icons/sumo-logic-logs-dark.svg": 86088,
	"@ui/styles/src/img/icons/pipeline-icons/sumo-logic-logs-light.svg": 32360,
	"@ui/styles/src/img/icons/pipeline-icons/sumo-logic-metrics-dark.svg": 39382,
	"@ui/styles/src/img/icons/pipeline-icons/sumo-logic-metrics-light.svg": 2278,
	"@ui/styles/src/img/icons/pipeline-icons/throttle-dark.svg": 97869,
	"@ui/styles/src/img/icons/pipeline-icons/throttle-light.svg": 15624,
	"@ui/styles/src/img/icons/pipeline-icons/trace-sampling-dark.svg": 96500,
	"@ui/styles/src/img/icons/pipeline-icons/trace-sampling-light.svg": 70044,
	"@ui/styles/src/img/icons/pipeline-icons/transform-group-dark.svg": 51667,
	"@ui/styles/src/img/icons/pipeline-icons/transform-group-input-dark.svg": 42686,
	"@ui/styles/src/img/icons/pipeline-icons/transform-group-input-light.svg": 7614,
	"@ui/styles/src/img/icons/pipeline-icons/transform-group-light.svg": 47225,
	"@ui/styles/src/img/icons/pipeline-icons/unroll-dark.svg": 86685,
	"@ui/styles/src/img/icons/pipeline-icons/unroll-light.svg": 61291,
	"@ui/styles/src/img/icons/pipeline-icons/vector-dark.svg": 12874,
	"@ui/styles/src/img/icons/pipeline-icons/vector-light.svg": 97458,
	"@ui/styles/src/img/icons/pipeline-icons/vrl-dark.svg": 97125,
	"@ui/styles/src/img/icons/pipeline-icons/vrl-light.svg": 61923,
	"@ui/styles/src/img/icons/pipeline-icons/webhook-dark.svg": 41300,
	"@ui/styles/src/img/icons/pipeline-icons/webhook-light.svg": 46076,
	"@ui/styles/src/img/icons/play.svg": 2036,
	"@ui/styles/src/img/icons/plug.svg": 53926,
	"@ui/styles/src/img/icons/plus.svg": 47818,
	"@ui/styles/src/img/icons/power.svg": 12185,
	"@ui/styles/src/img/icons/privacy-lock.svg": 98230,
	"@ui/styles/src/img/icons/pulse.svg": 59273,
	"@ui/styles/src/img/icons/question.svg": 6670,
	"@ui/styles/src/img/icons/quote.svg": 49698,
	"@ui/styles/src/img/icons/refresh.svg": 13659,
	"@ui/styles/src/img/icons/rewind.svg": 75451,
	"@ui/styles/src/img/icons/ribbon.svg": 37034,
	"@ui/styles/src/img/icons/rocket.svg": 22214,
	"@ui/styles/src/img/icons/search-minus.svg": 16149,
	"@ui/styles/src/img/icons/search-plus.svg": 64855,
	"@ui/styles/src/img/icons/search.svg": 49118,
	"@ui/styles/src/img/icons/security.svg": 33236,
	"@ui/styles/src/img/icons/server.svg": 21079,
	"@ui/styles/src/img/icons/shared-sources.svg": 46008,
	"@ui/styles/src/img/icons/shield.svg": 29637,
	"@ui/styles/src/img/icons/sign-out.svg": 74606,
	"@ui/styles/src/img/icons/slack-monochrome.svg": 24392,
	"@ui/styles/src/img/icons/sliders.svg": 37148,
	"@ui/styles/src/img/icons/sort-asc.svg": 54358,
	"@ui/styles/src/img/icons/sort-desc.svg": 11792,
	"@ui/styles/src/img/icons/sparkles.svg": 74471,
	"@ui/styles/src/img/icons/stack.svg": 38614,
	"@ui/styles/src/img/icons/sun.svg": 37100,
	"@ui/styles/src/img/icons/swap.svg": 63351,
	"@ui/styles/src/img/icons/tag.svg": 83086,
	"@ui/styles/src/img/icons/tap.svg": 42113,
	"@ui/styles/src/img/icons/template-library.svg": 90338,
	"@ui/styles/src/img/icons/terminal.svg": 21278,
	"@ui/styles/src/img/icons/time-cycle.svg": 40844,
	"@ui/styles/src/img/icons/toolbox.svg": 63847,
	"@ui/styles/src/img/icons/tools.svg": 75247,
	"@ui/styles/src/img/icons/trash.svg": 10096,
	"@ui/styles/src/img/icons/trusted-profile-icon.svg": 86279,
	"@ui/styles/src/img/icons/unfold.svg": 65834,
	"@ui/styles/src/img/icons/union.svg": 4755,
	"@ui/styles/src/img/icons/upload.svg": 28749,
	"@ui/styles/src/img/icons/user.svg": 53767,
	"@ui/styles/src/img/icons/verified.svg": 21486,
	"@ui/styles/src/img/icons/views.svg": 9872,
	"@ui/styles/src/img/icons/webhook-monochrome.svg": 88238,
	"@ui/styles/src/img/icons/wrench.svg": 65169,
	"@ui/styles/src/img/icons/x.svg": 90130,
	"@ui/styles/src/img/icons/zap.svg": 53923,
	"node_modules/@ui/styles/src/img/icons/add-host.svg": 64386,
	"node_modules/@ui/styles/src/img/icons/alert.svg": 76568,
	"node_modules/@ui/styles/src/img/icons/announcement.svg": 46427,
	"node_modules/@ui/styles/src/img/icons/archives.svg": 44627,
	"node_modules/@ui/styles/src/img/icons/area-chart.svg": 42710,
	"node_modules/@ui/styles/src/img/icons/arrow-back.svg": 33063,
	"node_modules/@ui/styles/src/img/icons/arrow-down.svg": 68402,
	"node_modules/@ui/styles/src/img/icons/arrow-left.svg": 88633,
	"node_modules/@ui/styles/src/img/icons/arrow-right.svg": 7172,
	"node_modules/@ui/styles/src/img/icons/arrow-up.svg": 13825,
	"node_modules/@ui/styles/src/img/icons/asterisk.svg": 39082,
	"node_modules/@ui/styles/src/img/icons/at.svg": 36141,
	"node_modules/@ui/styles/src/img/icons/attention.svg": 70632,
	"node_modules/@ui/styles/src/img/icons/bar-graph.svg": 60454,
	"node_modules/@ui/styles/src/img/icons/bell-filled.svg": 12622,
	"node_modules/@ui/styles/src/img/icons/bell-off.svg": 38425,
	"node_modules/@ui/styles/src/img/icons/bell.svg": 89749,
	"node_modules/@ui/styles/src/img/icons/book.svg": 19501,
	"node_modules/@ui/styles/src/img/icons/box.svg": 67973,
	"node_modules/@ui/styles/src/img/icons/building.svg": 92682,
	"node_modules/@ui/styles/src/img/icons/bulb.svg": 68467,
	"node_modules/@ui/styles/src/img/icons/calendar.svg": 28844,
	"node_modules/@ui/styles/src/img/icons/cancel-circle.svg": 69701,
	"node_modules/@ui/styles/src/img/icons/caret-down.svg": 50308,
	"node_modules/@ui/styles/src/img/icons/caret-right.svg": 49734,
	"node_modules/@ui/styles/src/img/icons/chat.svg": 16692,
	"node_modules/@ui/styles/src/img/icons/check-circle.svg": 40403,
	"node_modules/@ui/styles/src/img/icons/check.svg": 68342,
	"node_modules/@ui/styles/src/img/icons/chevron-down.svg": 14724,
	"node_modules/@ui/styles/src/img/icons/chevron-left.svg": 8003,
	"node_modules/@ui/styles/src/img/icons/chevron-right.svg": 70726,
	"node_modules/@ui/styles/src/img/icons/chevron-up.svg": 77375,
	"node_modules/@ui/styles/src/img/icons/circle-minus.svg": 25877,
	"node_modules/@ui/styles/src/img/icons/circle-plus.svg": 30071,
	"node_modules/@ui/styles/src/img/icons/circle.svg": 33406,
	"node_modules/@ui/styles/src/img/icons/clipboard.svg": 97316,
	"node_modules/@ui/styles/src/img/icons/clock.svg": 76292,
	"node_modules/@ui/styles/src/img/icons/clone.svg": 12541,
	"node_modules/@ui/styles/src/img/icons/code.svg": 64725,
	"node_modules/@ui/styles/src/img/icons/collapse.svg": 15447,
	"node_modules/@ui/styles/src/img/icons/compose.svg": 77518,
	"node_modules/@ui/styles/src/img/icons/context.svg": 48719,
	"node_modules/@ui/styles/src/img/icons/copy.svg": 93477,
	"node_modules/@ui/styles/src/img/icons/credit-card.svg": 9868,
	"node_modules/@ui/styles/src/img/icons/currency.svg": 71603,
	"node_modules/@ui/styles/src/img/icons/dash.svg": 11494,
	"node_modules/@ui/styles/src/img/icons/dashboard.svg": 42406,
	"node_modules/@ui/styles/src/img/icons/dashboardB.svg": 3736,
	"node_modules/@ui/styles/src/img/icons/delete.svg": 70767,
	"node_modules/@ui/styles/src/img/icons/deny.svg": 57552,
	"node_modules/@ui/styles/src/img/icons/description.svg": 60460,
	"node_modules/@ui/styles/src/img/icons/download.svg": 62806,
	"node_modules/@ui/styles/src/img/icons/drag.svg": 83652,
	"node_modules/@ui/styles/src/img/icons/drop-target.svg": 83653,
	"node_modules/@ui/styles/src/img/icons/educate.svg": 32699,
	"node_modules/@ui/styles/src/img/icons/email-monochrome.svg": 96196,
	"node_modules/@ui/styles/src/img/icons/enterprise.svg": 7283,
	"node_modules/@ui/styles/src/img/icons/envelope.svg": 36758,
	"node_modules/@ui/styles/src/img/icons/equals.svg": 72229,
	"node_modules/@ui/styles/src/img/icons/error.svg": 68108,
	"node_modules/@ui/styles/src/img/icons/exclamation-warning.svg": 22130,
	"node_modules/@ui/styles/src/img/icons/exclusion.svg": 29702,
	"node_modules/@ui/styles/src/img/icons/expand.svg": 51290,
	"node_modules/@ui/styles/src/img/icons/export.svg": 97096,
	"node_modules/@ui/styles/src/img/icons/extension.svg": 46425,
	"node_modules/@ui/styles/src/img/icons/eye-slash.svg": 79669,
	"node_modules/@ui/styles/src/img/icons/eye.svg": 59913,
	"node_modules/@ui/styles/src/img/icons/file-binary.svg": 41962,
	"node_modules/@ui/styles/src/img/icons/file-code.svg": 52582,
	"node_modules/@ui/styles/src/img/icons/filter.svg": 56932,
	"node_modules/@ui/styles/src/img/icons/fingerprint.svg": 92638,
	"node_modules/@ui/styles/src/img/icons/flag.svg": 47700,
	"node_modules/@ui/styles/src/img/icons/flame.svg": 41023,
	"node_modules/@ui/styles/src/img/icons/forward.svg": 39061,
	"node_modules/@ui/styles/src/img/icons/gear-outline.svg": 7354,
	"node_modules/@ui/styles/src/img/icons/gear.svg": 3295,
	"node_modules/@ui/styles/src/img/icons/genius.svg": 96209,
	"node_modules/@ui/styles/src/img/icons/gift.svg": 62208,
	"node_modules/@ui/styles/src/img/icons/github.svg": 22283,
	"node_modules/@ui/styles/src/img/icons/google.svg": 73211,
	"node_modules/@ui/styles/src/img/icons/group.svg": 61367,
	"node_modules/@ui/styles/src/img/icons/heart-empty.svg": 48878,
	"node_modules/@ui/styles/src/img/icons/heart-full.svg": 58624,
	"node_modules/@ui/styles/src/img/icons/help.svg": 24039,
	"node_modules/@ui/styles/src/img/icons/heroku.svg": 48798,
	"node_modules/@ui/styles/src/img/icons/histogram.svg": 96160,
	"node_modules/@ui/styles/src/img/icons/history.svg": 21814,
	"node_modules/@ui/styles/src/img/icons/id-badge.svg": 8191,
	"node_modules/@ui/styles/src/img/icons/info-outline.svg": 76463,
	"node_modules/@ui/styles/src/img/icons/keyboard.svg": 14525,
	"node_modules/@ui/styles/src/img/icons/keys.svg": 23698,
	"node_modules/@ui/styles/src/img/icons/launch.svg": 34823,
	"node_modules/@ui/styles/src/img/icons/layers.svg": 99932,
	"node_modules/@ui/styles/src/img/icons/line-chart.svg": 23651,
	"node_modules/@ui/styles/src/img/icons/link.svg": 10622,
	"node_modules/@ui/styles/src/img/icons/lock.svg": 74399,
	"node_modules/@ui/styles/src/img/icons/magic.svg": 69579,
	"node_modules/@ui/styles/src/img/icons/magnet.svg": 17764,
	"node_modules/@ui/styles/src/img/icons/microscope.svg": 28902,
	"node_modules/@ui/styles/src/img/icons/monitor.svg": 12492,
	"node_modules/@ui/styles/src/img/icons/moon.svg": 37509,
	"node_modules/@ui/styles/src/img/icons/more-alt.svg": 80595,
	"node_modules/@ui/styles/src/img/icons/more.svg": 82065,
	"node_modules/@ui/styles/src/img/icons/no-keys.svg": 46216,
	"node_modules/@ui/styles/src/img/icons/org-tree.svg": 23401,
	"node_modules/@ui/styles/src/img/icons/pagerduty-monochrome.svg": 24211,
	"node_modules/@ui/styles/src/img/icons/paper-clip.svg": 90543,
	"node_modules/@ui/styles/src/img/icons/pause-circle.svg": 62313,
	"node_modules/@ui/styles/src/img/icons/pause.svg": 38908,
	"node_modules/@ui/styles/src/img/icons/pencil.svg": 91741,
	"node_modules/@ui/styles/src/img/icons/pin.svg": 63531,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/aggregate-dark.svg": 48926,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/aggregate-light.svg": 79102,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/aggregate-v2-dark.svg": 71323,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/aggregate-v2-light.svg": 41489,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/azure-blob-storage-dark.svg": 60500,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/azure-blob-storage-light.svg": 67996,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/azure-event-hub-dark.svg": 10013,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/azure-event-hub-light.svg": 4171,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/blackhole-dark.svg": 24784,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/blackhole-light.svg": 12480,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/clickhouse-dark.svg": 38453,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/clickhouse-light.svg": 21235,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/cloudwatch-logs-dark.svg": 19193,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/cloudwatch-logs-light.svg": 23247,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/cloudwatch-metrics-dark.svg": 80797,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/cloudwatch-metrics-light.svg": 43915,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/clustering-dark.svg": 66223,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/clustering-light.svg": 78285,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/compact-fields-dark.svg": 65816,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/compact-fields-light.svg": 1048,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/conditional-dark.svg": 6529,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/conditional-light.svg": 57927,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/data-profiler-dark.svg": 90999,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/data-profiler-light.svg": 72293,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/datadog-logs-dark.svg": 71879,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/datadog-logs-light.svg": 66101,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/datadog-metrics-dark.svg": 14319,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/datadog-metrics-light.svg": 4141,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/decrypt-fields-dark.svg": 10732,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/decrypt-fields-light.svg": 23268,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/dedupe-dark.svg": 73002,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/dedupe-light.svg": 15826,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/demo-logs-dark.svg": 54992,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/demo-logs-light.svg": 2176,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/drop-fields-dark.svg": 23392,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/drop-fields-light.svg": 7504,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/elasticsearch-dark.svg": 70774,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/elasticsearch-light.svg": 89062,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/encrypt-fields-dark.svg": 64436,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/encrypt-fields-light.svg": 26844,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/event-to-metric-dark.svg": 2196,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/event-to-metric-light.svg": 24316,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/filter-by-field-dark.svg": 88696,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/filter-by-field-light.svg": 27160,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/filter-dark.svg": 87547,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/filter-light.svg": 92625,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/flatten-fields-dark.svg": 51313,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/flatten-fields-light.svg": 28759,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/fluent-dark.svg": 80123,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/fluent-light.svg": 56465,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/fluentd-dark.svg": 37675,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/fluentd-light-light.svg": 96490,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/gcp-cloud-monitoring-dark.svg": 52154,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/gcp-cloud-monitoring-light.svg": 73730,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/gcp-cloud-operations-dark.svg": 5026,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/gcp-cloud-operations-light.svg": 8026,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/gcp-cloud-pubsub-dark.svg": 33463,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/gcp-cloud-pubsub-light.svg": 16901,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/gcp-cloud-storage-dark.svg": 89263,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/gcp-cloud-storage-light.svg": 52685,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/generic-destination-dark.svg": 69273,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/generic-destination-light.svg": 91759,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/generic-processor-dark.svg": 71901,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/generic-processor-light.svg": 67051,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/generic-source-dark.svg": 47192,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/generic-source-light.svg": 84920,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/grafana-metrics-dark.svg": 34209,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/grafana-metrics-light.svg": 50119,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/honeycomb-logs-dark.svg": 647,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/honeycomb-logs-light.svg": 16789,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/http-dark.svg": 27105,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/http-light.svg": 51399,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/js-script-dark.svg": 616,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/js-script-light.svg": 13544,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/kafka-dark.svg": 50671,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/kafka-light.svg": 75373,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/kinesis-firehose-dark.svg": 22605,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/kinesis-firehose-light.svg": 54523,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/kinesis-streams-dark.svg": 9383,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/kinesis-streams-light.svg": 60149,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/kubernetes.svg": 17760,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/log-analysis-dark.svg": 17902,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/log-analysis-light.svg": 2254,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/logstash-dark.svg": 38506,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/logstash-light.svg": 28274,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/loki-dark.svg": 25192,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/loki-light.svg": 89160,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/map-fields-dark.svg": 93929,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/map-fields-light.svg": 22239,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/metrics-tag-cardinality-limit-dark.svg": 95626,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/metrics-tag-cardinality-limit-light.svg": 48594,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/mezmo-agent-dark.svg": 60225,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/mezmo-agent-light.svg": 72359,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/mezmo-dark.svg": 40541,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/mezmo-datadog-source-dark.svg": 81138,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/mezmo-datadog-source-light.svg": 72106,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/mezmo-light.svg": 65995,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/new-relic-dark.svg": 8801,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/new-relic-light.svg": 94023,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/notification-channel-dark.svg": 54156,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/notification-channel-light.svg": 3652,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/open-telemetry-dark.svg": 35507,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/open-telemetry-light.svg": 85337,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/parse-dark.svg": 19581,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/parse-light.svg": 34514,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/parse-sequentially-dark.svg": 12459,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/parse-sequentially-light.svg": 60737,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/prometheus-remote-write-dark.svg": 18514,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/prometheus-remote-write-light.svg": 76330,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/pulsar-dark.svg": 45872,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/pulsar-light.svg": 66464,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/redact-dark.svg": 48336,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/redact-light.svg": 85120,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/redis-dark.svg": 81542,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/redis-light.svg": 49078,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/reduce-dark.svg": 50111,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/reduce-light.svg": 15037,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/replace-dark.svg": 24073,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/replace-light.svg": 13631,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/route-dark.svg": 51592,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/route-light.svg": 12904,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/s3-dark.svg": 84607,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/s3-light.svg": 27933,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/sample-dark.svg": 98099,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/sample-light.svg": 23289,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/set-timestamp-dark.svg": 52304,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/set-timestamp-light.svg": 54176,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/splunk-dark.svg": 23582,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/splunk-hec-light.svg": 22149,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/splunk-hec-logs-dark.svg": 74059,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/splunk-hec-logs-light.svg": 89665,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/sqs-dark.svg": 16148,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/sqs-light.svg": 86972,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/stringify-dark.svg": 28916,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/stringify-light.svg": 40700,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/sumo-logic-logs-dark.svg": 86088,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/sumo-logic-logs-light.svg": 32360,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/sumo-logic-metrics-dark.svg": 39382,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/sumo-logic-metrics-light.svg": 2278,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/throttle-dark.svg": 97869,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/throttle-light.svg": 15624,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/trace-sampling-dark.svg": 96500,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/trace-sampling-light.svg": 70044,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/transform-group-dark.svg": 51667,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/transform-group-input-dark.svg": 42686,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/transform-group-input-light.svg": 7614,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/transform-group-light.svg": 47225,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/unroll-dark.svg": 86685,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/unroll-light.svg": 61291,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/vector-dark.svg": 12874,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/vector-light.svg": 97458,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/vrl-dark.svg": 97125,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/vrl-light.svg": 61923,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/webhook-dark.svg": 41300,
	"node_modules/@ui/styles/src/img/icons/pipeline-icons/webhook-light.svg": 46076,
	"node_modules/@ui/styles/src/img/icons/play.svg": 2036,
	"node_modules/@ui/styles/src/img/icons/plug.svg": 53926,
	"node_modules/@ui/styles/src/img/icons/plus.svg": 47818,
	"node_modules/@ui/styles/src/img/icons/power.svg": 12185,
	"node_modules/@ui/styles/src/img/icons/privacy-lock.svg": 98230,
	"node_modules/@ui/styles/src/img/icons/pulse.svg": 59273,
	"node_modules/@ui/styles/src/img/icons/question.svg": 6670,
	"node_modules/@ui/styles/src/img/icons/quote.svg": 49698,
	"node_modules/@ui/styles/src/img/icons/refresh.svg": 13659,
	"node_modules/@ui/styles/src/img/icons/rewind.svg": 75451,
	"node_modules/@ui/styles/src/img/icons/ribbon.svg": 37034,
	"node_modules/@ui/styles/src/img/icons/rocket.svg": 22214,
	"node_modules/@ui/styles/src/img/icons/search-minus.svg": 16149,
	"node_modules/@ui/styles/src/img/icons/search-plus.svg": 64855,
	"node_modules/@ui/styles/src/img/icons/search.svg": 49118,
	"node_modules/@ui/styles/src/img/icons/security.svg": 33236,
	"node_modules/@ui/styles/src/img/icons/server.svg": 21079,
	"node_modules/@ui/styles/src/img/icons/shared-sources.svg": 46008,
	"node_modules/@ui/styles/src/img/icons/shield.svg": 29637,
	"node_modules/@ui/styles/src/img/icons/sign-out.svg": 74606,
	"node_modules/@ui/styles/src/img/icons/slack-monochrome.svg": 24392,
	"node_modules/@ui/styles/src/img/icons/sliders.svg": 37148,
	"node_modules/@ui/styles/src/img/icons/sort-asc.svg": 54358,
	"node_modules/@ui/styles/src/img/icons/sort-desc.svg": 11792,
	"node_modules/@ui/styles/src/img/icons/sparkles.svg": 74471,
	"node_modules/@ui/styles/src/img/icons/stack.svg": 38614,
	"node_modules/@ui/styles/src/img/icons/sun.svg": 37100,
	"node_modules/@ui/styles/src/img/icons/swap.svg": 63351,
	"node_modules/@ui/styles/src/img/icons/tag.svg": 83086,
	"node_modules/@ui/styles/src/img/icons/tap.svg": 42113,
	"node_modules/@ui/styles/src/img/icons/template-library.svg": 90338,
	"node_modules/@ui/styles/src/img/icons/terminal.svg": 21278,
	"node_modules/@ui/styles/src/img/icons/time-cycle.svg": 40844,
	"node_modules/@ui/styles/src/img/icons/toolbox.svg": 63847,
	"node_modules/@ui/styles/src/img/icons/tools.svg": 75247,
	"node_modules/@ui/styles/src/img/icons/trash.svg": 10096,
	"node_modules/@ui/styles/src/img/icons/trusted-profile-icon.svg": 86279,
	"node_modules/@ui/styles/src/img/icons/unfold.svg": 65834,
	"node_modules/@ui/styles/src/img/icons/union.svg": 4755,
	"node_modules/@ui/styles/src/img/icons/upload.svg": 28749,
	"node_modules/@ui/styles/src/img/icons/user.svg": 53767,
	"node_modules/@ui/styles/src/img/icons/verified.svg": 21486,
	"node_modules/@ui/styles/src/img/icons/views.svg": 9872,
	"node_modules/@ui/styles/src/img/icons/webhook-monochrome.svg": 88238,
	"node_modules/@ui/styles/src/img/icons/wrench.svg": 65169,
	"node_modules/@ui/styles/src/img/icons/x.svg": 90130,
	"node_modules/@ui/styles/src/img/icons/zap.svg": 53923
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92173;